<script lang="ts" setup>
import BsLinkArrowButton from '@/legacy/components/LinkArrowButton.vue'
import { InfoSectionTheme } from '@/types/InfoSectionLegacy'

defineProps({
	theme: {
		type: String,
		default: InfoSectionTheme.Info,
	},
	icon: {
		type: String,
		default: '',
	},
	content: {
		type: String,
		default: '',
	},
	arrowText: {
		type: String,
		default: '了解更多',
	},
	isNoLink: {
		type: Boolean,
		default: false,
	},
	action: {
		type: Function,
	},
})
</script>

<template>
	<div
		class="bs-info-section"
		:class="[
			'mt-16px flex w-full items-start p-16px',
			{
				'bg-[#fff4e1]': theme === 'primary',
				'bg-[#fbfbfb]': theme === 'info',
			},
		]"
	>
		<div class="mr-8px flex h-20px w-20px items-start">
			<template v-if="icon === ''">
				<div
					class="inline-block h-16px w-16px bg-[length:100%_100%]"
					:style="{
						backgroundImage:
							theme === 'primary'
								? `url('data:image/svg+xml;charset=UTF-8,%3Csvg%20%20fill%3D%22%23FF9E1B%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10%205a1%201%200%20110%202%201%201%200%20010-2m0%204a1%201%200%20011%201v4a1%201%200%2001-2%200v-4a1%201%200%20011-1M11.694.14A10.013%2010.013%200%2000.14%2011.694c.681%204.143%204.023%207.485%208.166%208.166A10.013%2010.013%200%200019.86%208.306C19.179%204.163%2015.837.821%2011.694.14m-.126%2017.71C5.943%2018.926%201.074%2014.057%202.15%208.432c.601-3.144%203.138-5.681%206.282-6.282%205.625-1.076%2010.494%203.793%209.418%209.418-.601%203.144-3.138%205.681-6.282%206.282%22%2F%3E%3C%2Fsvg%3E')`
								: `url('data:image/svg+xml;charset=UTF-8,%3Csvg%20%20fill%3D%22%235DA2D5%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10%205a1%201%200%20110%202%201%201%200%20010-2m0%204a1%201%200%20011%201v4a1%201%200%2001-2%200v-4a1%201%200%20011-1M11.694.14A10.013%2010.013%200%2000.14%2011.694c.681%204.143%204.023%207.485%208.166%208.166A10.013%2010.013%200%200019.86%208.306C19.179%204.163%2015.837.821%2011.694.14m-.126%2017.71C5.943%2018.926%201.074%2014.057%202.15%208.432c.601-3.144%203.138-5.681%206.282-6.282%205.625-1.076%2010.494%203.793%209.418%209.418-.601%203.144-3.138%205.681-6.282%206.282%22%2F%3E%3C%2Fsvg%3E')`,
					}"
				></div>
			</template>
			<template v-else>
				<i :class="`bs-icon--${icon}`"></i>
			</template>
		</div>
		<div class="flex flex-col flex-wrap justify-start">
			<div class="text-[14px] leading-[1.2] text-[rgba(38,38,38,0.87)]">
				{{ content }}
			</div>
			<BsLinkArrowButton
				v-if="!isNoLink"
				class="mt-16px"
				:text="arrowText"
				:action="action"
				:theme="theme"
			/>
		</div>
	</div>
</template>
